import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { get, noop } from 'lodash';

import { Form } from 'components/Form';
import { Select } from 'components/Select';
import { api } from 'utils/api';
import { websiteSelector } from 'selectors';
import { changeWebsite } from 'actions';

const formName = 'ContentRelatedUploads';

const RELATED_UPLOADS_OPTION_IDS = ['keywords', 'topics', 'same_channel'];

const normalizeRelatedUploadsValue = (value) => {
  if (typeof value === 'string' && RELATED_UPLOADS_OPTION_IDS.includes(value)) {
    return value;
  }

  if (value && typeof value === 'object' && RELATED_UPLOADS_OPTION_IDS.includes(value.id)) {
    return value.id;
  }

  return 'keywords';
};

export function RelatedUploads(props) {
  const { t } = useTranslation();
  const { initialValues } = props;

  const options = [
    { id: 'keywords', name: t('content.relatedUploads.options.keywords') },
    { id: 'topics', name: t('content.relatedUploads.options.topics') },
    { id: 'same_channel', name: t('content.relatedUploads.options.sameChannel') },
  ];

  if (!initialValues) {
    return null;
  }

  return (
    <Form {...props} formTitle="content.relatedUploads.header">
      <div className="form-group">
        <Field
          name="relatedUploadsBasedOn"
          title={t('content.relatedUploads.label')}
          component={Select}
          options={options}
          formName={formName}
          isClearable={false}
          format={normalizeRelatedUploadsValue}
          normalize={normalizeRelatedUploadsValue}
        />
      </div>
    </Form>
  );
}

const getInitialFormValues = (website) => {
  const content = get(website, 'content');

  if (!content) {
    return null;
  }

  return {
    relatedUploadsBasedOn: normalizeRelatedUploadsValue(get(content, 'relatedUploadsBasedOn')),
  };
};

const saveRelatedUploads = (website) => (dispatch) => (formData) => {
  const content = get(website, 'content');

  return api
    .patch(`/websites/${website.id}`, {
      content: {
        ...content,
        relatedUploadsBasedOn: formData.relatedUploadsBasedOn,
      },
    })
    .then((websitePayload) => {
      dispatch(initialize(formName, getInitialFormValues(websitePayload)));
      dispatch(changeWebsite(websitePayload));
    });
};

export const RelatedUploadsDecorated = compose(
  connect(
    (state) => ({
      website: websiteSelector(state),
      formName,
    }),
    {
      saveRelatedUploads,
    },
    (stateProps, dispatchProps) => {
      const { website } = stateProps;
      const websiteId = get(website, 'id');

      return {
        formName,
        initialValues: websiteId ? getInitialFormValues(website) : null,
        onSubmit: websiteId ? dispatchProps.saveRelatedUploads(website) : noop,
      };
    }
  ),
  reduxForm({
    form: formName,
    touchOnChange: true,
    enableReinitialize: true,
  })
)(RelatedUploads);

